import React, {useEffect, useContext} from "react";
import { Row, Col, Button, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import Alerts from "../client_config/seo_config/alerts/Alerts";
import {RouterContext} from "./Onboarding"

export default function SeoAlerts(props) {
  const route = useContext(RouterContext)

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem(
      "routerHistory",
      JSON.stringify([...route.get])
    );
  }, [route.get]);
  props.pageLocator();
  return (
    <Container fluid className="px-lg-5 px-0">
      <Row className="justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">SEO Alerts</p>
          </div>

          <div>
            <p className=" f14 nunito-regular primary ">
              We need to make sure SEO alerts are configured correctly. By default, we have automatically subscribed team
              support/leads accordingly based on how they were assigned in the Service Agreement, but if you need to make any changes or customizations, you can
              do so below.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="tab-shadow mt-3 mx-lg-5 mx-0 justify-content-center">
        <Col>
          <Alerts {...props} onboarding />
        </Col>
      </Row>
      <Row className="mt-5 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton 
              btnText={`Skip for now`}
              nextPage={nextPage.url}
            />
            <NextButton
              validated={true} 
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
